import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Language } from '../App';
import { SectionHeading } from '../components/SectionHeading';
export function FundingPage({
  language
}: {
  language: Language;
}) {
  const ar = language === 'ar';
  const steps = ar ? ['الطلب', 'التقييم', 'العناية الواجبة', 'الموافقة', 'التمويل', 'دعم مستمر'] : ['Application', 'Evaluation', 'Due Diligence', 'Approval', 'Funding', 'Ongoing Support'];
  return <>
      <section className="relative isolate overflow-hidden bg-[#071f37] py-24" data-id="element-144">
        <img src="https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?auto=format&fit=crop&w=1800&q=85" alt="Business district architecture" className="absolute inset-0 h-full w-full object-cover opacity-25" data-id="element-145" />
        <div className="relative mx-auto max-w-7xl px-5 lg:px-8" data-id="element-146">
          <SectionHeading language={language} light eyebrow={ar ? 'الاستثمار والتمويل' : 'Investment & funding'} title={ar ? 'رأس مال دولي، بعقلية محلية.' : 'International capital, locally minded.'} text={ar ? 'نربط الفرص المؤهلة بشبكة تمويل عالمية تعمل وفق معايير واضحة.' : 'We connect qualified opportunities with a global funding network operating to clear standards.'} data-id="element-147" />
        </div>
      </section>
      <section className="bg-white py-20" data-id="element-148">
        <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-[1.1fr_.9fr] lg:px-8" data-id="element-149">
          <div data-id="element-150">
            <SectionHeading language={language} eyebrow={ar ? 'شبكة قوية' : 'A strong network'} title={ar ? 'إتاحة رأس المال للفرص المؤهلة.' : 'Making capital available to qualified opportunities.'} data-id="element-151" />
            <p className="mt-6 leading-8 text-slate-600" data-id="element-152">
              {ar ? 'تعمل UNITED THIRD FINANCIAL COMPANY مع شبكة دولية من شركاء التمويل والممولين. يتيح هذا الرأس المال تقديم القروض التجارية وتمويل الأعمال المؤهلة والمشاريع المرتبطة بالجهات الحكومية وتطوير القطاع الخاص والعقود التجارية الكبيرة.' : 'United Third Financial Company works with an international network of funding partners and financiers. This capital enables commercial lending and the financing of qualified businesses, government-related projects, private sector developments, and large commercial contracts.'}
            </p>
            <p className="mt-5 leading-8 text-slate-600" data-id="element-153">
              {ar ? 'نقيّم كل فرصة باستقلالية ونبني هيكل تمويل يتناسب مع أهدافها ومخاطرها وجدولها التنفيذي.' : 'We assess each opportunity independently and build a financing structure aligned with its objectives, risk profile, and delivery timetable.'}
            </p>
          </div>
          <aside className="bg-[#f4f0e7] p-8" data-id="element-154">
            <h2 className="font-serif text-2xl text-[#08233f]" data-id="element-155">
              {ar ? 'نهجنا في الشراكة' : 'Our partnership approach'}
            </h2>
            <ul className="mt-6 space-y-5" data-id="element-156">
              {(ar ? ['نهج سري ومنضبط', 'معايير تقييم واضحة', 'استجابة مهنية وسريعة', 'علاقات مبنية على المدى الطويل'] : ['Confidential, disciplined engagement', 'Clear assessment standards', 'Professional, responsive delivery', 'Long-term relationship focus']).map(item => <li key={item} className="flex gap-3 text-sm text-[#29455f]" data-id="element-157">
                  <CheckIcon size={18} className="shrink-0 text-[#a47b2a]" data-id="element-158" />
                  {item}
                </li>)}
            </ul>
          </aside>
        </div>
      </section>
      <section className="bg-[#f2f4f5] py-20" data-id="element-159">
        <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-160">
          <SectionHeading language={language} centered eyebrow={ar ? 'سير العمل' : 'Funding workflow'} title={ar ? 'من التقييم إلى شراكة مستمرة.' : 'From evaluation to enduring partnership.'} data-id="element-161" />
          <div className="mt-12 grid gap-px bg-slate-300 sm:grid-cols-2 lg:grid-cols-6" data-id="element-162">
            {steps.map((step, index) => <div className="bg-white p-6" key={step} data-id="element-163">
                <span className="text-xs font-bold text-[#b89142]" data-id="element-164">
                  0{index + 1}
                </span>
                <p className="mt-8 text-sm font-bold" data-id="element-165">{step}</p>
              </div>)}
          </div>
        </div>
      </section>
    </>;
}